import React from 'react';
import { HowWeWorkAttributes } from '@app/models/dtos/strapi';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import Item from '@app/components/item';

function HowWeWorkUi({ howWeWork }: { howWeWork: HowWeWorkAttributes }) {
    return (
        <div className="mb-[80px] flex w-full flex-col items-center md:mb-[160px]">
            <div className="container w-full">
                <p className="P2  !text-black-1 ">How We Work</p>
                <p className="h4-responsive mt-2 max-w-[640px] text-black-1 md:mt-6">{howWeWork.title}</p>
                <div className="mt-[30px] grid grid-flow-row grid-cols-1 gap-[66px] sm:grid-cols-2 md:mt-[60px] md:grid-cols-3 lg:grid-cols-4">
                    {howWeWork.steps && howWeWork.steps.map((step, index) => <Item index={index + 1} key={step.id} item={step} hasStep={true} />)}
                </div>
            </div>
        </div>
    );
}

export default HowWeWorkUi;
